import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../shared/models/response.model';
import { Module } from '../models/module.model';
import { CreateRequest } from './requests/create-request';
import { ModuleUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class ModuleService {
  #http = inject(HttpClient);
  readonly BASE_URL = '/modules';

  créer(data: CreateRequest) {
    return this.#http.post<Module>(this.BASE_URL, data);
  }

  trouveParId(idModule: string) {
    return this.#http.get<Module>(this.BASE_URL + '/' + idModule);
  }

  trouverTous = (idParcours: string) => this.#http.get<Response<Module>>(this.BASE_URL, { params: { idParcours } });

  modifier(idModule: string, data: ModuleUpdateRequest) {
    return this.#http.put<string>(this.BASE_URL + '/' + idModule, data);
  }

  dupliquer = (idModule: string, idÉtape: string) =>
    this.#http.post<Module>(this.BASE_URL + '/duplication/' + idModule, { idEtape: idÉtape });

  supprimer = (idModule: string) => this.#http.delete(this.BASE_URL + '/' + idModule);
}
